import { RESOURCE_PERMISSIONS_MAP } from './resourcePermissionMap';
import RESOURCE_PERMISSION_TYPE from './resourcePermissionType';

export const permissionOptions = [
  {
    label: RESOURCE_PERMISSIONS_MAP[RESOURCE_PERMISSION_TYPE.ATL].Label,
    value: RESOURCE_PERMISSIONS_MAP[RESOURCE_PERMISSION_TYPE.ATL].Value,
    displayName: RESOURCE_PERMISSIONS_MAP[RESOURCE_PERMISSION_TYPE.ATL].Label
  },
  {
    label: RESOURCE_PERMISSIONS_MAP[RESOURCE_PERMISSION_TYPE.ATM].Label,
    value: RESOURCE_PERMISSIONS_MAP[RESOURCE_PERMISSION_TYPE.ATM].Value,
    displayName: RESOURCE_PERMISSIONS_MAP[RESOURCE_PERMISSION_TYPE.ATM].Label
  },
  {
    label: RESOURCE_PERMISSIONS_MAP[RESOURCE_PERMISSION_TYPE.SPONSOR_COORDINATOR].Label,
    value: RESOURCE_PERMISSIONS_MAP[RESOURCE_PERMISSION_TYPE.SPONSOR_COORDINATOR].Value,
    displayName: RESOURCE_PERMISSIONS_MAP[RESOURCE_PERMISSION_TYPE.SPONSOR_COORDINATOR].Label
  },
  {
    label: RESOURCE_PERMISSIONS_MAP[RESOURCE_PERMISSION_TYPE.FDA_ADMIN_REVIEWER].Label,
    value: RESOURCE_PERMISSIONS_MAP[RESOURCE_PERMISSION_TYPE.FDA_ADMIN_REVIEWER].Value,
    displayName: RESOURCE_PERMISSIONS_MAP[RESOURCE_PERMISSION_TYPE.FDA_ADMIN_REVIEWER].Label
  },
  {
    label: RESOURCE_PERMISSIONS_MAP[RESOURCE_PERMISSION_TYPE.VIP_PARTNER].Label,
    value: RESOURCE_PERMISSIONS_MAP[RESOURCE_PERMISSION_TYPE.VIP_PARTNER].Value,
    displayName: RESOURCE_PERMISSIONS_MAP[RESOURCE_PERMISSION_TYPE.VIP_PARTNER].Label
  },
  {
    label: RESOURCE_PERMISSIONS_MAP[RESOURCE_PERMISSION_TYPE.VIP_FREE_LICENSE].Label,
    value: RESOURCE_PERMISSIONS_MAP[RESOURCE_PERMISSION_TYPE.VIP_FREE_LICENSE].Value,
    displayName: RESOURCE_PERMISSIONS_MAP[RESOURCE_PERMISSION_TYPE.VIP_FREE_LICENSE].Label
  }
];
